import { useEffect } from "react";

/**
 * Prompts the user for confirmation if they try to refresh or close the tab
 * while the form has unsaved changes.
 *
 * @param isDirty - Boolean from react-hook-form indicating if the form has been modified.
 * @param isSubmitting - Boolean indicating if the form is currently submitting (to prevent warning on valid submit).
 */
export const useUnsavedChangesWarning = (
  isDirty: boolean,
  isSubmitting: boolean
) => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Only warn if form is dirty AND we aren't in the middle of a valid submission
      if (isDirty && !isSubmitting) {
        // Modern standard to trigger the dialog
        e.preventDefault();

        // Legacy support: required for some browsers (older Chrome/Edge) to show the dialog.
        // We cast to 'any' to silence the TypeScript deprecation warning.
        (e as any).returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty, isSubmitting]);
};
